import LegalDocPage from '@/components/LegalDocPage';

const VendorTermsOfService = () => <LegalDocPage documentType="vendor_terms" title="Vendor Terms of Service" />;

export default VendorTermsOfService;
